import { render, staticRenderFns } from "./ManualList.vue?vue&type=template&id=20939305&scoped=true&lang=pug"
import script from "./ManualList.vue?vue&type=script&lang=ts"
export * from "./ManualList.vue?vue&type=script&lang=ts"
import style0 from "./ManualList.vue?vue&type=style&index=0&id=20939305&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20939305",
  null
  
)

export default component.exports